/**
 * Review carousel pager dots call scrollIntoView when the viewport resizes.
 * On mobile that resize happens as soon as the user scrolls (browser chrome
 * collapses), and scrollIntoView moves the document to the reviews block.
 * Scroll the dots inside their own row instead.
 */
(function () {
  var native = Element.prototype.scrollIntoView;

  Element.prototype.scrollIntoView = function (options) {
    if (this.classList && this.classList.contains('dcr3__pagination-dot')) {
      var scroller = this.parentElement;
      if (scroller) {
        var left = this.offsetLeft - (scroller.clientWidth - this.offsetWidth) / 2;
        scroller.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
      return;
    }

    return native.call(this, options);
  };
})();
